<script>
export default {
    name: 'IconConversation'
}
</script>
<template>
    <svg
        class="base-icon icon-conversation"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M56 32v24l-6-6H32V32h24zM52 8v20H28v12h-8L8 52V8h44z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
